import React from 'react';
import {
  Card, Grid, UserPreview,
  ActionIcon,
  ICON_EYE_OUTLINE,
  DetailStack,
  UserPreviewProps,
  ActionIconProps,
} from '@doveit/bricks';
import { Contact } from '../../../providers/api/dtos';
import { NO_VALUE_SYMBOL } from '../../../property/utils';
import DateViewer from '../../../components/date-viewer/DateViewer';
import { HighlightContactDataConfig } from '../../types';
import ViewContactAction from '../../containers/view-contact-action/ViewContactAction';

export interface ContactCardProps extends React.AriaAttributes {
  contact: Contact,
  details?: UserPreviewProps['children'],
  primaryAction?: React.ReactElement<ActionIconProps>,
  highlight?: HighlightContactDataConfig,
}

const ContactCard: React.FC<ContactCardProps> = ({
  contact,
  details,
  primaryAction,
  highlight,
  'aria-label': ariaLabel = 'Card con informazioni contatto',
  ...rest
}) => (
  <Card
    {...rest}
    aria-label={ariaLabel}
  >
    <Card.Header
      primaryActions={[
        primaryAction,
        <ViewContactAction contactId={contact.id!} sameTab>
          {({ onClick }) => (
            <ActionIcon
              label="Visualizza"
              aria-label="Visualizza contatto"
              size="S"
              icon={{ path: ICON_EYE_OUTLINE }}
              onClick={onClick}
            />
          )}
        </ViewContactAction>,
      ]}
    >
      <UserPreview
        name={contact.name || NO_VALUE_SYMBOL}
        size="S"
      >
        {details}
      </UserPreview>
    </Card.Header>

    <Card.Content>
      <Grid gutter={150}>
        <Grid.Unit size={1 / 2}>
          <DetailStack
            label="Telefono"
            color={highlight?.fields.phoneNumber ? highlight.color : undefined}
          >
            {contact.phoneNumber || NO_VALUE_SYMBOL}
          </DetailStack>
        </Grid.Unit>
        <Grid.Unit size={1 / 2}>
          <DetailStack label="Aggiunto">
            <DateViewer
              stringDate={contact.createdAt!}
              checkIfToday
            />
          </DetailStack>
        </Grid.Unit>
        <Grid.Unit>
          <DetailStack
            label="Email"
            color={highlight?.fields.email ? highlight.color : undefined}
          >
            {contact.email || NO_VALUE_SYMBOL}
          </DetailStack>
        </Grid.Unit>
      </Grid>
    </Card.Content>
  </Card>
);

export default ContactCard;
